export default "__VITE_ASSET__6e966784__"